import { Colors } from '@eservices/ui-constants/colors';
import styled from 'styled-components';

const Footnote = styled.div`
    color: ${Colors.GRAY_SEPTENARY};
    font-size: 12px;
`;

export default Footnote;
